import React from "react";
import { useNavigate } from "react-router-dom"
import { Row, Col, Typography, Button, ExpandableText } from '../../ui/ot';
import defaultBlogTypeData from './blog_type_data';
import useBlogMedia from './use_blog_media'; // 引入自定義 hook

const LatestNewsPage = ({
    blogTypeData = defaultBlogTypeData
}) => {
    const navigate = useNavigate();
    const {
        files,
        get_picture,
        toLinkSomewhere,
        isMoreContentEmpty,
        renderMediaContent,
    } = useBlogMedia(blogTypeData); // 使用自定義 hook
    return (
        <Row gutter={[8, 8]} justify={'center'}
            style={{
                backgroundImage: `linear-gradient(to bottom right, #E6F7FF, #F5E6FF)`,
                padding: "1rem"
            }}>
            {blogTypeData.map((blogType) =>
                <>
                    {
                        !Boolean(blogTypeData?.blog_type_hidden_name) && blogTypeData.blog_type_name && blogTypeData.blog_type_name.length !== 0 && (

                        <Col span={24} style={{ textAlign: 'center' }}>
                            <Typography.Title level={3}>
                                {blogType.blog_type_name}
                            </Typography.Title>
                        </Col>
                    )}

                    <Col span={20}>
                        <Row gutter={[8, 8]} justify={'start'}
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                            }}>
                            {blogType.frontend_column_frontend_component_blog_type_blog_data.map((blog) => (
                                <Col xxl={12}
                                    xl={12}
                                    lg={12}
                                    md={24}
                                    sm={24}
                                    xs={24}
                                    style={{
                                        textAlign: "left",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: "100%", /* 保證高度一致 */
                                    }}
                                >
                                    <Row gutter={[8, 8]}
                                        style={{
                                            margin: "20px 0",
                                            padding: "20px",
                                            borderRadius: "8px",
                                            backgroundColor: "#f9f9f9",
                                        }}
                                    >
                                        <Col span={24}>
                                            <Typography.Title level={4}
                                                style={{ color: "#0056B3", fontWeight: "bold" }}
                                            >
                                                {blog.title}
                                            </Typography.Title>
                                        </Col>
                                        <Col span={24}>
                                            <ExpandableText
                                                minHeight={false}
                                                style={{
                                                    fontSize: "1rem",
                                                }}
                                                text={blog?.content}
                                                maxLines={5}
                                            />
                                        </Col>
                                        {
                                            blog?.more_content &&
                                            !isMoreContentEmpty(blog.more_content) &&
                                            <Col span={24}
                                                style={{
                                                    textAlign: "right"
                                                }}
                                            >
                                                <Button
                                                    size={"small"}
                                                    type={'link'}
                                                    onClick={e => navigate(`/officialweb/frontend/moreContent/${blog.blog_id}`)}
                                                >
                                                    詳細內容
                                                </Button>
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                            ))}
                            <Col span={24}
                                style={{
                                    textAlign: 'right'
                                }}>
                                <Button type={'link'}
                                    onClick={(e) => navigator("/")}
                                    style={{
                                        color: "#0056B3",
                                        textDecoration: "underline",
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                    }}
                                >
                                    更多消息
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </>
            )}
        </Row>
    );
};

export default LatestNewsPage;
